<template>
    <div>
        <div class="repeat" v-for="(item, index) in dates" :key="index">
            <v-layout row wrap>
                <v-flex xs12 sm6 md4 px-4>
                    <v-dialog
                        :ref="'dialogDate' + index"
                        v-model="item.modalDate"
                        :return-value.sync="item.date"
                        persistent
                        lazy
                        full-width
                        width="290px">

                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="item.formatedDate"
                                label="Escolha o dia"
                                prepend-icon="event"
                                readonly
                                v-on="on">
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="item.date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="white" @click="item.modalDate = false">Cancelar</v-btn>
                            <!-- <v-btn flat color="white" @click="xx">OK</v-btn> -->
                            <v-btn flat color="white" @click="save(item.date, index, 'dialogDate')">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex xs12 sm6 md4 px-4>
                    <v-dialog
                        :ref="'dialogTime' + index"
                        v-model="item.modalTime"
                        :return-value.sync="item.time"
                        persistent
                        lazy
                        full-width
                        width="290px">

                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="item.time"
                                label="Hora do início"
                                prepend-icon="access_time"
                                readonly
                                v-on="on">
                            </v-text-field>
                        </template>

                        <v-time-picker
                            v-model="item.time"
                            full-width>

                            <v-spacer></v-spacer>
                            <v-btn flat color="white" @click="item.modalTime = false">Cancel</v-btn>
                            <v-btn flat color="white" @click="save(item.time, index, 'dialogTime')">OK</v-btn>
                        </v-time-picker>
                    </v-dialog>
                </v-flex>
                <v-flex xs12 sm6 md4 px-4>
                    <v-dialog
                        :ref="'dialogTimeEnd' + index"
                        v-model="item.modalTimeEnd"
                        :return-value.sync="item.timeEnd"
                        persistent
                        lazy
                        full-width
                        width="290px">

                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="item.timeEnd"
                                label="Hora de encerramento"
                                prepend-icon="access_time"
                                readonly
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-time-picker
                            v-model="item.timeEnd"
                            full-width>

                            <v-spacer></v-spacer>
                            <v-btn flat color="white" @click="item.modalTimeEnd = false">Cancel</v-btn>
                            <v-btn flat color="white" @click="save(item.timeEnd, index, 'dialogTimeEnd')">OK</v-btn>
                        </v-time-picker>
                    </v-dialog>
                </v-flex>
            </v-layout>
        </div>
        <button @click="addItem">[+] Adicionar dia</button>
        <br/>
        <br/>
    </div>
</template>

<script>
export default {
    props: [ 'value', 'currentItem' ],
    data() {
        return {
            dates: []
        }
    },
    created() {
        if( typeof this.$props.currentItem.data != 'undefined' ) {
            const transform = JSON.parse(JSON.stringify(this.$props.currentItem.data));
            this.dates = transform.map( el => {
                el.formatedDate = el.date;
                el.date = el.date.split('/').reverse().join('-');

                return el;
            });

            this.$emit('change', this.dates.map( el => {
                return {
                    date: el.formatedDate,
                    time: el.time,
                    timeEnd: el.timeEnd
                }
            }));
        }
    },
    methods: {
        addItem() {
            this.dates.push({
                modalDate: false,
                modalTime: false,
                modalTimeEnd: false,
                date: '',
                formatedDate: '',
                time: '',
                timeEnd: ''
            })
        },
        save( value, idx, type ){
            if(type == 'dialogDate'){
                this.dates.map((el,index) => {
                    if(index==idx){
                        el.formatedDate = this.formatDate(el.date);
                    }
                    return el;
                });
            }
            const item = this.dates.find( (el,index) => index == idx );
            var value;
            if(type == 'dialogDate'){
                value = item.date;
            } else if(type == 'dialogTime') {
                value = item.time;
            } else {
                value = item.timeEnd;
            }
            this.$refs[type + idx][0].save(value);

            this.$emit('change', this.dates.map( el => {
                return {
                    date: el.formatedDate,
                    time: el.time,
                    timeEnd: el.timeEnd
                }
            }))
        },
        formatDate( date ){
            return date.split('-').reverse().join('/');
        }
    }
}
</script>